import { useEffect, useState } from 'react';

import { isNil } from 'ramda';

import { queries } from 'RestAPIs/rapini';

import { ConvertedDutyCalculationValueSleepDuty } from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/types';
import { convertToInternal } from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/utils/utils';

const useGetDutyCalculationValueSleepDutyTableData = () => {
  const { data, isFetching } = queries.useGetDutyCalculationValueSleepDuties();
  const [convertedData, setConvertedData] =
    useState<ConvertedDutyCalculationValueSleepDuty[]>();

  useEffect(() => {
    if (!isNil(data)) {
      setConvertedData(
        data.map<ConvertedDutyCalculationValueSleepDuty>((a) =>
          convertToInternal(a)
        )
      );
    }
  }, [data]);

  return { convertedData, isFetching };
};

export default useGetDutyCalculationValueSleepDutyTableData;
